/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetStudySiteInfoResponse } from '../models/GetStudySiteInfoResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ClinTrakStudySiteService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param siteId
     * @returns GetStudySiteInfoResponse
     * @throws ApiError
     */
    public clinTrakStudySiteGeStudySiteByPcsSiteId(
        siteId: number,
    ): Observable<GetStudySiteInfoResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/clintrak/sites/{siteId}/info',
            path: {
                'siteId': siteId,
            },
        });
    }
}
